// Остаток наличных сотрудника по валютам — для филиала без мультивалютных касс (admin/users/List.vue).
// Общий счёт `account.cash` — легаси-скаляр: каждый платёж пишет и в него, и в счёт кассы (`currency_accounts`), во всех
// валютах без пересчёта. Если у сотрудника деньги в разных валютах (касса другого филиала, мультивалютность выключили
// позже), скаляр складывает рубли с долларами: staging 2026-10-08 — 1 447 124,5 ₽ + 100 $ = «1 447 224,5». Тогда
// остаток — по валютам; нулевые счета не показываются (staging 15.10: «0.00 · 100.00 $ · 1 515 …» не влезало и начиналось
// с пустого евро); валюта филиала (`base` — company.currency: где код «RUB», где символ «€»; символ сверяется по `currencies` филиала) первой, остальные — по убыванию суммы. Деньги только в одной
// валюте (или ни в одной) — null: экран показывает скаляр как раньше. Так же отдаёт агент (api cashboxes).
export function cashByCurrency(currencyAccounts, { base, currencies } = {}) {
  const sums = new Map();
  (currencyAccounts || []).forEach((account) => {
    if (!account || account.currency_id == null) return;
    const row = sums.get(account.currency_id) || {
      currency_id: account.currency_id,
      code: (account.currency && account.currency.code) || null,
      cash: 0,
    };
    row.cash += parseFloat(account.cash) || 0;
    sums.set(account.currency_id, row);
  });
  const rows = [...sums.values()]
    .map((row) => ({ ...row, cash: Math.round(row.cash * 100) / 100 }))
    .filter((row) => row.cash !== 0);
  if (rows.length <= 1) return null;
  const symbolOf = (row) => {
    const currency = (currencies || []).find((item) => item.id == row.currency_id);
    return currency && currency.symbol;
  };
  const isBase = (row) => base != null && base !== "" && (row.code === base || symbolOf(row) === base);
  return rows.sort((a, b) => (isBase(b) - isBase(a)) || (Math.abs(b.cash) - Math.abs(a.cash)));
}

// «1 515 824,50 ₽»: разряды и копейки по языку интерфейса; значок — из валют филиала (`currencies`: [{ id, symbol }]),
// иначе код счёта (валюты другого филиала в списке филиала нет).
export function cashLabel(row, { locale, currencies } = {}) {
  let amount;
  try {
    amount = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.cash);
  } catch (e) {
    amount = row.cash.toFixed(2);
  }
  const currency = (currencies || []).find((item) => item.id == row.currency_id);
  return `${amount} ${(currency && currency.symbol) || row.code || ""}`.trim();
}
